// extracted by mini-css-extract-plugin
export default {"banner_box":"index_banner_box_tAtpC","banner":"index_banner_JM-Mm"};